var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0623 0.0405273V11.7126C15.0623 22.8251 10.119 30.1002 0.925171 32.4453V24.2109C4.76258 22.2922 6.4148 19.1343 6.4148 13.7779H0.925171V0.0405273H15.0623ZM36.0748 0.0405273V11.7126C36.0748 22.8251 31.1314 30.1002 21.9377 32.4453V24.2109C25.7751 22.2922 27.4273 19.1343 27.4273 13.7779H21.9377V0.0405273H36.0748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.e2f8df7a8c1673aac4f5c646755893a2.svg";
export { ForwardRef as ReactComponent };